/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsaveragepeople2Inputs */

const en_statsaveragepeople2 = /** @type {(inputs: Statsaveragepeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg. people per plan`)
};

const de_statsaveragepeople2 = /** @type {(inputs: Statsaveragepeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø Personen pro Plan`)
};

/**
* | output |
* | --- |
* | "Avg. people per plan" |
*
* @param {Statsaveragepeople2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsaveragepeople2 = /** @type {((inputs?: Statsaveragepeople2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsaveragepeople2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsaveragepeople2(inputs)
	return de_statsaveragepeople2(inputs)
});
export { statsaveragepeople2 as "statsAveragePeople" }